import {
  GET_AUTO_COMPLETE_SUGGESTIONS,
  GET_AUTO_COMPLETE_SUGGESTIONS_FAILED,
  GET_AUTO_COMPLETE_SUGGESTIONS_SUCCESS,
  GET_EMPTY_SEARCH_SUGGESTIONS,
  GET_EMPTY_SEARCH_SUGGESTIONS_FAILED,
  GET_EMPTY_SEARCH_SUGGESTIONS_SUCCESS,
  RESET_AUTO_COMPLETE_SUGGESTIONS,
  SUGGESTIONS_FETCHING_STATUS,
  type Action,
} from '../HeaderLeonidas.searchBar.actions';
import {
  suggestionsInitialState,
  type SuggestionsState,
} from '../HeaderLeonidas.searchBar.model';
import { BestCategoryHit } from '../interfaces/algolia';

export default function reducer(
  state: SuggestionsState = suggestionsInitialState,
  action: Action,
): SuggestionsState {
  switch (action.type) {
    case SUGGESTIONS_FETCHING_STATUS: {
      const { status } = action;

      return {
        ...state,
        isFetching: status,
      };
    }

    // AutoComplete
    case GET_AUTO_COMPLETE_SUGGESTIONS:
      return {
        ...state,
        isFetching: true,
        termQuery: action.query,
      };

    case GET_AUTO_COMPLETE_SUGGESTIONS_SUCCESS: {
      const { termQuery, resultsQueries, bestCategoryEnabled } = action;

      const categoryRedirection = resultsQueries.categories?.userData?.[0];
      const brandRedirection = resultsQueries.brands?.userData?.[0];
      const bestCategoryRedirection = resultsQueries.bestCategory?.hits?.find(
        ({ is_reliable }: BestCategoryHit) => is_reliable,
      );

      return {
        ...state,
        isFetching: false,
        termQuery,
        redirections: {
          category: categoryRedirection,
          brand: brandRedirection,
          ...(bestCategoryEnabled &&
            bestCategoryRedirection && {
              bestCategory: {
                categoryId: bestCategoryRedirection.category_id,
                categoryName: bestCategoryRedirection.category_name,
                categorySlug: bestCategoryRedirection.category_slug,
              },
            }),
        },
      };
    }

    case GET_AUTO_COMPLETE_SUGGESTIONS_FAILED:
      return {
        ...state,
        isFetching: false,
        error: action.error,
        termQuery: action.query || '',
        redirections: {},
      };

    case RESET_AUTO_COMPLETE_SUGGESTIONS:
      return {
        ...state,
        isFetching: false,
        termQuery: '',
        redirections: {},
      };

    // EmptySearch
    case GET_EMPTY_SEARCH_SUGGESTIONS:
      return {
        ...state,
        isFetching: true,
      };

    case GET_EMPTY_SEARCH_SUGGESTIONS_SUCCESS: {
      return {
        ...state,
        isFetching: false,
      };
    }

    case GET_EMPTY_SEARCH_SUGGESTIONS_FAILED: {
      const { error } = action;

      return {
        ...state,
        isFetching: false,
        error,
      };
    }

    default:
      return state;
  }
}
